import type { InvivoMaterialPlan } from "../types/invivo_scene";

export function validateLegacyBackgroundPreset(backgroundValue: string): void {
  const normalizedValue = backgroundValue.replace(/^d-/, "").replace(/^#/, "");
  const isColor = /^[a-f0-9]{6}$/i.test(normalizedValue);

  if (isColor || normalizedValue === "or" || normalizedValue === "gp" || normalizedValue === "none") {
    return;
  }

  throw new Error(`Unsupported background preset "${normalizedValue}".`);
}

export function validateLegacyMaterialPlan(materialPlan: InvivoMaterialPlan): void {
  if (materialPlan.kind !== "sheet") {
    return;
  }

  if (
    !materialPlan.previewTexture ||
    !materialPlan.albedoRoughnessTexture ||
    !materialPlan.xycaTexture ||
    !materialPlan.dotsTexture ||
    !materialPlan.crumplesTexture ||
    !materialPlan.creasesTexture
  ) {
    throw new Error(`Missing required legacy sheet textures for material "${materialPlan.name}".`);
  }
}
